import { Fragment } from 'react'
import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { es } from 'date-fns/locale'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import StoreIcon from '@mui/icons-material/Store'
import EventIcon from '@mui/icons-material/Event'
import DatePicker from '@mui/lab/DatePicker'
import { makeStyles, styled } from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'
import moment from 'moment'
import CheckoutBuyerForm from '../CheckoutBuyerForm'
import CheckoutShipmentForm from '../CheckoutShipmentForm'
import { formatter } from '../../utils/auxFunc'

const steps = ['ENVÍO', 'PAGO', 'RESUMEN']

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiStepConnector-root': {
      top: '18px',
      left: 'calc(-50% + 25px)',
      right: 'calc(50% + 25px)'
    },
    '& .MuiSvgIcon-root.MuiStepIcon-root': { width: '1.4em', height: '1.4em' },
    '& .MuiStepIcon-root.Mui-active': {
      color: '#292929',
      border: '1px solid #292929',
      borderRadius: '50%',
      '& .MuiStepIcon-text': {
        fill: '#FAFAFA'
      }
    },
    '& .MuiStepIcon-root.Mui-completed': {
      color: '#9b9797',
      border: '1px solid #292929',
      borderRadius: '50%'
    },
    '& .Mui-disabled .MuiStepIcon-root': {
      color: '#FAFAFA',
      border: '1px solid #292929',
      borderRadius: '50%'
    }
  }
}))

const CheckoutRadio = styled(Radio)(({ theme }) => ({
  '& .Mui-checked': {
    color: theme.palette.secondary.main
  }
}))

const ShipmentInfo = ({
  addresses,
  freeShippingAmount,
  shipmentCost,
  deliveryTimes,
  buyerForm,
  setBuyerForm,
  shipmentForm,
  setShipmentForm,
  withdrawalDate,
  setWithdrawalDate,
  destinationForm,
  setDestinationForm,
  states,
  carriers,
  getTotalAmount,
  handleSubmit,
  register,
  Controller,
  control,
  errors,
  closeCheckout,
  activeStep,
  handleNext,
  deliveryTimeOfProduct,
  handleChange,
  observationsCheckout,
  handleObservationsFieldChange,
  errorMessages
}) => {
  const classes = useStyles()

  const handleRadio = (evt) => {
    let shipmentMethod
    switch (evt.target.value) {
      case 'caba':
        shipmentMethod = 1
        break
      case 'interiorDomicilio':
        shipmentMethod = 2
        break
      case 'interiorSucursal':
        shipmentMethod = 3
        break
      case 'sucursal':
        shipmentMethod = 4
        break
      default:
        shipmentMethod = 0
    }

    setShipmentForm({
      shipmentOption: evt.target.value,
      shipmentMethod: shipmentMethod
    })
  }

  const disableWeekends = (date) => {
    return date.getDay() === 0 || date.getDay() === 6
  }

  const daysEnableds = () => {
    if (new Date().getDay() === 4 || new Date().getDay() === 5) {
      return moment().add(11, 'days').toDate()
    } else if (new Date().getDay() === 6) {
      return moment().add(10, 'days').toDate()
    } else {
      return moment().add(9, 'days').toDate()
    }
  }

  const shipmentMessage = () => {
    if (shipmentForm.shipmentOption === 'caba') return 'Envío bonificado'
    else return 'Envío bonificado hasta transporte'
  }

  return (
    <Fragment>
      <Box sx={{ backgroundColor: (theme) => theme.palette.secondary.main }}>
        <Container
          maxWidth="lg"
          sx={{ display: 'flex', position: 'relative', minHeight: '64px' }}
        >
          <Typography
            variant="h5"
            color="primary"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexGrow={1}
          >
            Checkout
          </Typography>

          <Box sx={{ position: 'absolute', top: '.3rem', right: '2rem' }}>
            <Tooltip title="Cerrar">
              <IconButton
                size="large"
                aria-label="carrito"
                aria-controls="logo-carrito"
                aria-haspopup="false"
                color="inherit"
                onClick={closeCheckout}
              >
                <CloseIcon color="primary" sx={{ fontSize: '2rem' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Container>
      </Box>
      <Container
        sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
      >
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{ padding: '1.5rem 0' }}
          className={classes.root}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Container>
      <CheckoutBuyerForm
        handleSubmit={handleSubmit}
        buyerForm={buyerForm}
        setBuyerForm={setBuyerForm}
        register={register}
        errors={errors}
      />
      <Container
        sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
      >
        <Box display="flex" justifyContent="space-between" pt={3}>
          <Typography
            variant="subtitle1"
            color={(theme) => theme.palette.light.main}
            sx={{
              fontSize: '1rem'
            }}
          >
            Método de envío:
          </Typography>
        </Box>
      </Container>
      <Container sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
        <FormControl fullWidth>
          <RadioGroup
            aria-labelledby="Selección método de envío"
            defaultValue=""
            name="opciones de envío"
            onChange={handleRadio}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              width="100%"
            >
              <Box display="flex" alignItems="center" width="100%">
                <StoreIcon />
                <FormControlLabel
                  value="sucursal"
                  checked={shipmentForm.shipmentOption === 'sucursal'}
                  control={
                    <CheckoutRadio
                      sx={{
                        '&.Mui-checked': {
                          color: '#292929'
                        }
                      }}
                    />
                  }
                  label="Retirar por sucursal"
                  labelPlacement="start"
                  sx={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'space-between'
                  }}
                />
              </Box>
              {shipmentForm.shipmentOption === 'sucursal' && (
                <Container>
                  <Typography
                    variant="subtitle2"
                    sx={{ paddingLeft: '17px', fontStyle: 'italic' }}
                  >
                    Podra visualizar la dirección de retiro en Mi Cuenta/Pedidos
                    pendientes
                  </Typography>
                </Container>
              )}
            </Box>
            <Box display="flex" alignItems="center" width="100%">
              <LocalShippingIcon />
              <FormControlLabel
                value="caba"
                checked={shipmentForm.shipmentOption === 'caba'}
                control={
                  <CheckoutRadio
                    sx={{
                      '&.Mui-checked': {
                        color: '#292929'
                      }
                    }}
                  />
                }
                label="Envío a domicilio en CABA y GBA"
                labelPlacement="start"
                sx={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'space-between'
                }}
              />
            </Box>
            <Box display="flex" alignItems="center" width="100%">
              <LocalShippingIcon />
              <FormControlLabel
                value="interiorDomicilio"
                checked={shipmentForm.shipmentOption === 'interiorDomicilio'}
                control={
                  <CheckoutRadio
                    sx={{
                      '&.Mui-checked': {
                        color: '#292929'
                      }
                    }}
                  />
                }
                label="Envío por despacho al interior - Domicilio"
                labelPlacement="start"
                sx={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'space-between'
                }}
              />
            </Box>
            <Box display="flex" alignItems="center" width="100%">
              <LocalShippingIcon />
              <FormControlLabel
                value="interiorSucursal"
                checked={shipmentForm.shipmentOption === 'interiorSucursal'}
                control={
                  <CheckoutRadio
                    sx={{
                      '&.Mui-checked': {
                        color: '#292929'
                      }
                    }}
                  />
                }
                label="Envío por despacho al interior - Sucursal / Terminal"
                labelPlacement="start"
                sx={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'space-between'
                }}
              />
            </Box>
          </RadioGroup>
        </FormControl>

        <Typography variant="caption" color="error">
          {/* {error} */}
        </Typography>
      </Container>
      {shipmentForm.shipmentOption === 'sucursal' ? (
        <Fragment>
          <Container
            sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
          >
            <Box display="flex" justifyContent="space-between" pt={3}>
              <Typography
                variant="subtitle1"
                color={(theme) => theme.palette.light.main}
                sx={{
                  fontSize: '1rem'
                }}
              >
                Fecha de retíro:
              </Typography>
            </Box>
          </Container>
          <Container
            sx={{
              display: 'flex',
              alignItems: 'center',
              paddingTop: '1.5rem',
              paddingBottom: '1.5rem'
            }}
          >
            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
              <EventIcon />
              <DatePicker
                shouldDisableDate={disableWeekends}
                minDate={moment().add(1, 'days').toDate()}
                maxDate={daysEnableds()}
                inputFormat="dd-MM-yyyy"
                value={
                  withdrawalDate.withdrawalDate
                  // ||
                  // moment().add(1, "days").toDate()
                }
                onChange={(newValue) =>
                  setWithdrawalDate({ withdrawalDate: newValue })
                }
                DialogProps={{
                  sx: {
                    textTransform: 'capitalize'
                  }
                }}
                toolbarTitle="Seleccione una fecha"
                cancelText={
                  <Box
                    component="span"
                    color={(theme) => theme.palette.secondary.main}
                  >
                    Cancelar
                  </Box>
                }
                okText={
                  <Box
                    component="span"
                    color={(theme) => theme.palette.secondary.main}
                  >
                    Ok
                  </Box>
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Elegir fecha"
                    sx={{
                      marginLeft: '1rem'
                    }}
                  />
                )}
              ></DatePicker>
            </LocalizationProvider>
          </Container>
        </Fragment>
      ) : (
        <CheckoutShipmentForm
          addresses={addresses}
          deliveryTimes={deliveryTimes}
          states={states}
          destinationForm={destinationForm}
          setDestinationForm={setDestinationForm}
          carriers={carriers}
          handleSubmit={handleSubmit}
          Controller={Controller}
          control={control}
          register={register}
          errors={errors}
          deliveryTimeOfProduct={deliveryTimeOfProduct}
          handleChange={handleChange}
          shipmentForm={shipmentForm}
          errorMessages={errorMessages}
        />
      )}

      <Container
        sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
      >
        <Box display="flex" justifyContent="space-between" pt={3}>
          <Typography
            variant="subtitle1"
            color={(theme) => theme.palette.light.main}
            sx={{
              fontSize: '1rem'
            }}
          >
            Observaciones:
          </Typography>
        </Box>
      </Container>

      <Container sx={{ pt: 3, pb: 3 }}>
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={4}
          defaultValue={observationsCheckout.observationsField}
          fullWidth
          type="text"
          name="observationsField"
          onChange={handleObservationsFieldChange}
        />
      </Container>

      <Container
        sx={{
          backgroundColor: (theme) => theme.palette.lightBg.main,
          paddingTop: '4rem'
        }}
      ></Container>
      {shipmentCost.shipmentCost !== 0 && (
        <Fragment>
          <Container sx={{ pt: 3, pb: 3 }}>
            <Typography>
              {`Recorda que en compras superiores a ${formatter(0).format(
                freeShippingAmount
              )} tenes tu envío Bonificado`}
            </Typography>
          </Container>
          <Container
            sx={{
              backgroundColor: (theme) => theme.palette.lightBg.main,
              paddingTop: '4rem'
            }}
          ></Container>
        </Fragment>
      )}
      <Box
        py={2}
        sx={{ position: 'relative', bottom: 0, left: 0, width: '100%' }}
      >
        <Container>
          <Box display="flex" justifyContent="space-between">
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: '1rem'
              }}
            >
              Subtotal:
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: '1rem'
              }}
            >
              {formatter().format(getTotalAmount())}
            </Typography>
          </Box>
          {shipmentForm.shipmentOption !== 'sucursal' && (
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                Envío:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {shipmentCost.shipmentCost === 0
                  ? shipmentMessage()
                  : formatter().format(
                      shipmentCost.shipmentCost * shipmentCost.dolarValue
                    )}
                {shipmentForm.shipmentOption === 'interior' && ' *'}
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="space-between">
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: '1rem',
                fontWeight: '600'
              }}
            >
              Total:
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: '1rem',
                fontWeight: '600'
              }}
            >
              {shipmentForm.shipmentOption === 'sucursal'
                ? formatter().format(getTotalAmount())
                : formatter().format(
                    getTotalAmount() +
                      shipmentCost.shipmentCost * shipmentCost.dolarValue
                  )}
            </Typography>
          </Box>
          {shipmentForm.shipmentOption === 'interior' && (
            <Box>
              <Typography variant="caption">
                * Debera abonar el costo desde el transporte hasta su domicilio
                en la empresa que haya seleccionado
              </Typography>
            </Box>
          )}
        </Container>

        <Box pb={3} mt={2}>
          <Container maxWidth="sm">
            <Button
              color="secondary"
              variant="contained"
              fullWidth
              disableElevation
              onClick={() => {
                handleNext()
              }}
              sx={{
                fontWeight: 'bold',
                textTransform: 'capitalize'
              }}
            >
              Siguiente
            </Button>
          </Container>
        </Box>
      </Box>
      {/* </form> */}
    </Fragment>
  )
}

export default ShipmentInfo
